module.exports = __webpack_public_path__ + "static/media/md-expand.82e1cfae.svg";